import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { getAdminToken, adminMe } from '@/lib/api';

/**
 * Vérifie la session admin :
 * - Pas de token → redirect /admin/login
 * - Token présent mais backend refuse (/admin/me KO) → clear + redirect
 */
export default function AdminProtectedRoute({ children }) {
  const [state, setState] = useState('checking'); // 'checking' | 'ok' | 'ko'
  const navigate = useNavigate();

  useEffect(() => {
    const t = getAdminToken();
    if (!t) {
      setState('ko');
      return;
    }
    let alive = true;
    (async () => {
      const me = await adminMe();
      if (!alive) return;
      if (me?.ok) setState('ok');
      else {
        setState('ko');
      }
    })();
    return () => { alive = false; };
  }, [navigate]);

  if (state === 'checking') {
    return (
      <div className="grid min-h-screen place-items-center bg-[var(--om-bg)]" data-testid="admin-checking">
        <div className="flex items-center gap-3 text-sm text-[var(--om-muted)]">
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-[var(--om-ink)]" />
          Vérification de votre session…
        </div>
      </div>
    );
  }
  if (state === 'ko') {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
